/**
 * The Expert panel's QueryClient.
 *
 * Two deliberate differences from the user app:
 *
 *   staleTime 0          Experts work a SHARED pool with no assignment step
 *                        (US-01-001.1). Two of them can be looking at the same
 *                        query; a dashboard that serves a thirty-second-old cache
 *                        is a dashboard where someone answers a query that was
 *                        answered while they read it.
 *   refetchOnWindowFocus the reporting dashboard reflects new activity when the
 *                        Panel Lead comes back to the tab, with no deploy and no
 *                        manual cache refresh (US-01-006.15).
 */

import { retryDelay, shouldRetry } from "@anthra/platform/errors"
import { QueryClient } from "@tanstack/react-query"

export function createQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				retry: shouldRetry,
				retryDelay,
				refetchOnWindowFocus: true,
				staleTime: 0,
			},
			mutations: {
				// A retried 'Send Response' would post a second message and send a
				// second notification (US-01-001.24). Retrying is the Expert's
				// decision, with the same idempotency key.
				retry: 0,
			},
		},
	})
}
